import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { createPortal } from 'react-dom'
import { Button } from '@/components/ui/Button'

export function Lightbox({
  open,
  src,
  alt = '',
  onClose,
}: {
  open: boolean
  src: string | null
  alt?: string
  onClose: () => void
}) {
  const { t } = useTranslation()
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open || !src) return null

  return createPortal(
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4"
      style={{ background: 'rgba(3, 3, 4, 0.95)' }}
      role="presentation"
      onClick={onClose}
    >
      <Button
        type="button"
        variant="ghost"
        aria-label={t('common.close')}
        className="stryzh-btn--close-icon absolute right-4 top-4 z-[61]"
        onClick={(e) => {
          e.stopPropagation()
          onClose()
        }}
      >
        ✕
      </Button>
      <img
        src={src}
        alt={alt}
        className="max-h-[min(90vh,100%)] max-w-[min(96vw,100%)] object-contain"
        onClick={(e) => e.stopPropagation()}
      />
    </div>,
    document.body,
  )
}
